import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthenticationService } from '../authentication/authentication.service';

@Injectable({ providedIn: 'root' })
export class AuthenticationGuard implements CanActivate
{
    constructor(private authenticationService: AuthenticationService, private router: Router) { }

    async canActivate(): Promise<boolean>
    {
        const ok = await this.authenticationService.checkLoginAsync();
        if (!ok) this.router.navigate(['/login']);
        return ok;
    }
}
